import { useState } from "react";
import AdminLayout from "../admin/AdminLayout";
import ProfileForm from "../admin/ProfileForm";
import CollectionEditor from "../admin/CollectionEditor";

const SECTION_TABLE_MAP = {
  estudios: "studies",
  experiencia: "experience",
  proyectos: "projects",
  habilidades: "skills",
  idiomas: "languages",
  certificados: "certifications",
  categorias: "categories",
};

export default function Admin() {
  const [section, setSection] = useState("perfil");

  const tableKey = SECTION_TABLE_MAP[section];

  return (
    <AdminLayout active={section} onSelect={setSection}>
      {section === "perfil" && <ProfileForm />}
      {tableKey && <CollectionEditor table={tableKey} />}
    </AdminLayout>
  );
}
